export function apiErrorMessage(err: unknown, fallback: string): string {
  const res = (
    err as { response?: { status?: number; data?: { message?: unknown } } }
  )?.response
  if (res?.status !== undefined && res.status >= 500) return fallback
  const data = res?.data?.message
  if (Array.isArray(data)) return String(data[0] ?? fallback)
  if (typeof data === 'string' && data.length > 0) return data
  return fallback
}
